import React from 'react';

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
  registerProps?: Record<string, unknown>;
}

export default function TextInput({
  hasError,
  registerProps,
  ...props
}: TextInputProps) {
  return (
    <input
      className="w-full rounded-lg px-4 py-3 text-sm font-sans transition-all duration-150 outline-none"
      style={{
        border: `1px solid ${hasError ? '#a34f42' : 'var(--input)'}`,
        backgroundColor: 'var(--card)',
        color: 'var(--foreground)',
        fontFamily: 'var(--font-sans)',
      }}
      onFocus={(e) => {
        e.currentTarget.style.borderColor = hasError
          ? '#a34f42' :'var(--primary)';
        e.currentTarget.style.boxShadow = `0 0 0 3px ${
          hasError ? 'rgba(163,79,66,0.12)' : 'rgba(155,107,77,0.12)'
        }`;
      }}
      onBlur={(e) => {
        e.currentTarget.style.borderColor = hasError
          ? '#a34f42' :'var(--input)';
        e.currentTarget.style.boxShadow = 'none';
      }}
      {...registerProps}
      {...props}
    />
  );
}